export default __webpack_public_path__ + "static/media/le_mont10.6be06813.jpg";